import React from 'react';
import '../../../App.css';
import CardItem from '../../CardItem';
import Footer from '../../Footer';
import {
  poolHeatingPng,
  poolHeater2Jpg,
  poolHeater3Jpg,
} from '../../../images/assets';

export default function laptopPoolHeating() {
  return(
    <>
        <div style={{backgroundColor:'rgb(248, 248, 248)'}}>

      <div style={{marginLeft:'25%' ,width:'50%', padding:20, textAlign:'center', display: 'inherit', alignItems: 'center', justifyContent: 'center',}}>
            <CardItem
              src={poolHeatingPng}
              text='Swimming Pool Heating'
              path='/pool-heating'
            />
            </div>
    <div style={{width:'90%', padding:10, display: 'flex', flexDirection:'row'}}>
  
    <div >
            <div style={{padding:25 }}>
          <text style={{ fontSize:24}}>Swimming Pool Heating</text>
          </div>
          <div style={{marginLeft:25, width:800, color:'rgb(50, 50, 50)'}}>
          <text style={{ fontSize:20}}>Global Heating offers swimming pool heating solutions
          using the best technology designed to keep your pool or spa at the perfect
 temperature for your enjoyment.
           </text>
          </div>
          
          <div style={{marginTop:20, marginBottom:20}}>
          <text style={{ fontSize:20, marginLeft:25}}> The main component: </text>
          <div style={{marginLeft:25, width:500, color:'rgb(0, 0, 0)',fontSize:18,fontWeight:'bolder' }}>
            <text>1- Sleek and stylish swimming pool heaters,</text>
            </div>
            <div style={{marginLeft:25, width:500, color:'rgb(50, 50, 50)',fontSize:18 }}>
            <text>Built to withstand various weather conditions,
                    this modern pool and spa heater is the perfect
                    solution for environments requiring efficiency,
                    convenience and versatility. Whether upgrading
                    your existing system or adding a new pool or spa
                    to your home, our heater offers you flexible
                    installation solutions.

                    Thanks to a brilliant low-profile design,
                    corrosion resistant cabinet made of galvanized
                    metal, copper fin tube heat exchanger, and a
                    bevy of advanced-engineered materials,
                    enjoying your heater year round is a breeze.
                    </text>
            </div>
            
          </div>     
            </div>
            <div style={{marginLeft:200, width:'50%'}}>
            <CardItem
              src={poolHeater2Jpg}
              text='Digital Gas Low NOx heater'
              path='/pool-heating'
            />
            </div>
            </div>
         
            <div style={{width:'90%', padding:10, display: 'flex', flexDirection:'row'}}>
    <div >
    <div style={{padding:25 }}>
          <text style={{ fontSize:24}}>What are the benefits of swimming pool heaters?</text>
          </div>
          <div style={{marginLeft:25, width:800, color:'rgb(50, 50, 50)',fontSize:20, marginBottom:10 }}>
            <text>- Enjoy swimming all the year</text>
            </div>
             
            </div>
            <div style={{marginLeft:200, width:'50%'}}>
            <CardItem
              src={poolHeater3Jpg}
              text='Heated swimming pool'
              path='/pool-heating'
            />
            </div>
            </div>

            <div style={{width:'90%', padding:10, display: 'flex', flexDirection:'row'}}>
   
           
            </div>
            <section id="contact">
      <Footer />
      </section>
       </div>
    </>
  )
}
